import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Mivo from "./pages/Mivo";
import Detail from "./pages/Detail/Detail";
import LiveData from "./pages/LiveData/LiveData";
import CompareData from "./pages/CompareData/CompareData";
import DetailYoutube from "./pages/DetailYoutube/DetailYoutube";
import View from "./pages/View/View";
// import Test from "./pages/Test/Test";

function App() {
  return (
    <div className="container">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mivo" element={<Mivo />} />
          <Route path="/detail/:tv" element={<Detail />} />
          <Route path="/detail/youtube/:tv" element={<DetailYoutube />} />
          <Route path="/live-data" element={<LiveData />} />
          <Route path="/compare-data" element={<CompareData />} />
          <Route path="/view" element={<View />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
